import React from 'react';

import { styled } from '@mui/material';

import imgNetSuiteLogo from 'assets/images/netSuiteLogo.svg';



const StyledImg = styled('img')({
  maxWidth: 32
});

export interface IProps {
  type: 'customer' | 'salesOrder';
  urlToRecord: string;
}

export const FC: React.FC<IProps> = props => {

  return (
    <a
      href={props.urlToRecord}
      rel="noreferrer"
      target="_blank">
      <StyledImg src={imgNetSuiteLogo} />
    </a>
  );
};
